import React,{useState,useEffect} from 'react'
import { useParams } from 'react-router-dom'
import Title from '../../../../components/panelcontrols/paneltitle'
import Input from '../../../../components/panelcontrols/panelinput'
import TextArea from '../../../../components/panelcontrols/paneltextarea'
import Button from '../../../../components/panelcontrols/panelbuttonmain'
import Button2 from '../../../../components/panelcontrols/panelbuttonsecond'
import Select from '../../../../components/panelcontrols/panelselect'
import './index.css'
import Lineitems from './lineitems';
import Files from './files';
import Notes from './notes';
import Tasks from './tasks';
import LineItemsAdd from './lineitems/add'
import DoctorFunctions from '../../doctors/functions'
import DepartmentFunctions from '../departments/functions'
import StatusFunctions from '../status/functions'
import Functions from './functions'
import { ToastContainer, toast } from 'react-toastify';

const Index = () => {
  const { id: editId } = useParams();
  const isEdit = !!editId;
  const [patient,setPatient] = useState('');
  const [doctor,setDoctor] = useState({value:0,name:'Select doctor/clinic'});
  const [doctorlist,setDoctorList] = useState([]);
  const [date,setDate] = useState('');
  const [workingpan,setWorkingPan] = useState('');
  const [status,setStatus] = useState({value:0,name:'Select status'});
  const [statuslist,setStatusList] = useState([]);
  const [department,setDepartment] = useState({value:0,name:'Select department'});
  const [departmentlist,setDepartmentList] = useState([]);
  const [lineitems,setLineitems] = useState([]);
  const [notes,setNotes] = useState([]);
  const [files,setFiles] = useState([]);
  const [tasks,setTasks] = useState([]);
  const [page,setPage] = useState(0);
  const [editingIndex,setEditingIndex] = useState(null);
  const [subtotal,setSubTotal] = useState(0);
  const [discount,setDiscount] = useState(0);
  const [nettotal,setNetTotal] = useState(0);
  useEffect(()=>{
    DoctorFunctions.Get((data)=>{
      const sendData = [];
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        sendData.push({
          value : parseInt(element.id),
          name : element.firstname + " " + element.lastname + " / " + element.clinicname
        })
      }
      setDoctorList(sendData)
    })
    DepartmentFunctions.Get((data)=>{
      const sendData = [];
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        sendData.push({
          value : parseInt(element.id),
          name : element.name
        })
      }
      setDepartmentList(sendData)
    })
    StatusFunctions.Get((data)=>{
      const sendData = [];
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        sendData.push({
          value : parseInt(element.id),
          name : element.name
        })
      }
      setStatusList(sendData)
    })
  },[])
  useEffect(()=>{
    var subtotalsend = 0;
    for (let index = 0; index < lineitems.length; index++) {
      const element = lineitems[index];
      subtotalsend = subtotalsend + parseInt(element.totalprice);
    }
    setSubTotal(subtotalsend);
    setNetTotal(subtotalsend - parseInt(discount));
  },[lineitems,discount])
  useEffect(()=>{
    if(!editId) return;
    Functions.GetById(parseInt(editId), (order)=>{
      setPatient(order.patient || '');
      setDoctor({ value: order.doctorId, name: order.doctorname });
      setDate(order.date ? String(order.date).split('T')[0] : '');
      setWorkingPan(order.workingpan || '');
      setStatus({ value: order.status, name: order.statusname });
      setDepartment({ value: order.department, name: order.departmentname });
      setDiscount(order.discount || 0);
      const mappedLineitems = (order.items || []).map(it => {
        const sectionsArr = it.sections || {};
        const unitList = [
          ...(sectionsArr.S1||[]),
          ...(sectionsArr.S2||[]),
          ...(sectionsArr.S3||[]),
          ...(sectionsArr.S4||[])
        ].map(uId => ({ id: parseInt(uId) }));
        return {
          product:      { value: it.productid, name: it.productname },
          service:      { value: it.service,   name: it.servicename },
          shades:       it.shades || '',
          enclosed:     { value: it.enclosed,     name: it.enclosed },
          translucency: { value: it.translucency, name: it.translucency },
          occlusal:     { value: it.occlusal,     name: it.occlusal },
          ponticdesign: { value: it.ponticdesign, name: it.ponticdesign },
          duedate:      it.duedate ? String(it.duedate).split('T')[0] : '',
          appointment:  it.appointment ? String(it.appointment).split('T')[0] : '',
          units:        it.units,
          unitList:     unitList,
          totalprice:   it.totalprice,
          description:  it.description || ''
        };
      });
      setLineitems(mappedLineitems);
      setNotes((order.notes || []).map(n => typeof n === 'string' ? n : n.note));
      setTasks((order.tasks || []).map(t => typeof t === 'string' ? t : t.task));
    });
  },[editId])
  const reset = ()=>{
    setPatient('');
    setDoctor({value:0,name:'Select doctor/clinic'});
    setDate('');
    setWorkingPan('');
    setStatus({value:0,name:'Select status'});
    setDepartment({value:0,name:'Select department'});
    setLineitems([]);
    setFiles([]);
    setNotes([]);
    setTasks([]);
    setSubTotal(0);
    setDiscount(0);
    setEditingIndex(null);
  }
  return (
    <div className='labadmin_orders_new_container'>
      <Title Value={isEdit ? 'Edit order' : 'New order'}/>
      {page === 0 &&
        <div className='labadmin_orders_new_formbox'>
          <div className='labadmin_orders_new_row'>
            <div className='labadmin_orders_new_col50'>
              <Select Lable={'Client'} Value={doctor} setValue={setDoctor} Options={doctorlist}/>
            </div>
            <div className='labadmin_orders_new_col50'>
              <Input Lable={'Patient'} Type={'text'} Value={patient} setValue={setPatient}/>
            </div>
          </div>
          <div className='labadmin_orders_new_row'>
            <div className='labadmin_orders_new_col50'>
              <Input Lable={'Date'} Type={'date'} Value={date} setValue={setDate}/>
            </div>
            <div className='labadmin_orders_new_col50'>
              <Input Lable={'Working Pan'} Type={'text'} Value={workingpan} setValue={setWorkingPan}/>
            </div>
          </div>
          <div className='labadmin_orders_new_row'>
            <div className='labadmin_orders_new_col50'>
              {/*
                <Select Lable={'Status'} Value={status} setValue={setStatus} Options={statuslist}/>
              */}
            </div>
            <div className='labadmin_orders_new_col50'>
              <Select Lable={'Department'} Value={department} setValue={setDepartment} Options={departmentlist}/>
            </div>
          </div>
          <div className='labadmin_orders_new_row'>
            <div className='labadmin_orders_new_col50'>
              <Lineitems lineitems={lineitems} setLineitems={setLineitems} setPage={setPage} setEditingIndex={setEditingIndex}/>
            </div>
            <div className='labadmin_orders_new_col50'>
              <Files lineitems={files} setLineitems={setFiles} setPage={setPage}/>
            </div>
          </div>
          <div className='labadmin_orders_new_row'>
            <div className='labadmin_orders_new_col50'>
              <Notes notes={notes} setNotes={setNotes} setPage={setPage}/>
            </div>
            <div className='labadmin_orders_new_col50'>
              <Tasks tasks={tasks} setTasks={setTasks} setPage={setPage}/>
            </div>
          </div>
          <div className='labadmin_orders_new_row'>
            <div className='labadmin_orders_new_col33'>
              <Input Lable={'Sub Total'} Type={'number'} Value={subtotal} setValue={setSubTotal} readonly={true}/>
            </div>
            <div className='labadmin_orders_new_col33'>
              <Input Lable={'Discount'} Type={'number'} Value={discount} setValue={setDiscount}/>
            </div>
            <div className='labadmin_orders_new_col33'>
              <Input Lable={'Net Total'} Type={'number'} Value={nettotal} setValue={setNetTotal} readonly={true}/>
            </div>
          </div>
          <div className='labadmin_orders_new_row'>
            <div className='labadmin_orders_new_col50'>
              <Button Value={'Save'} Action={()=>{
                const toastid = toast.loading("Please wait ...",{ position: toast.POSITION.BOTTOM_CENTER});
                if(doctor.value === 0 || patient === '' || date === '' || workingpan === '' || department.value === 0 || lineitems.length === 0 || nettotal === 0 ){
                  toast.update(toastid, { render: "Fields Empty", type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
                  return;
                }
                const lineitemsSend = [];
                for (let index = 0; index < lineitems.length; index++) {
                  const element = lineitems[index];
                  const unitListSend = [];
                  for (let jndex = 0; jndex < element.unitList.length; jndex++) {
                    const uitem = element.unitList[jndex];
                    unitListSend.push(uitem.id);
                  }
                  lineitemsSend.push({
                    service: element.service.value,
                    shades: element.shades,
                    enclosed: element.enclosed.value,
                    translucency: element.translucency.value,
                    occlusal:element.occlusal.value,
                    ponticdesign:element.ponticdesign.value,
                    duedate: element.duedate,
                    appointment: element.appointment,
                    units: element.units,
                    totalprice: element.totalprice,
                    description: element.description,
                    unitlist: unitListSend
                  })
                }
                const payload = {
                  doctor: doctor.value,
                  patient: patient,
                  date: date,
                  workingpan: workingpan,
                  status: status.value,
                  department: department.value,
                  subtotal : subtotal,
                  discount: discount,
                  nettotal: nettotal,
                  notes: notes,
                  tasks: tasks,
                  lineitems: lineitemsSend
                };
                const callback = ()=>{
                  reset();
                  setTimeout(() => {
                    document.location.replace('/labadmin/orders');
                  }, 500);
                };
                if(isEdit){
                  Functions.Put({...payload, id: parseInt(editId)}, toast, toastid, callback);
                } else {
                  Functions.Post(payload, toast, toastid, callback);
                }
              }}/>
            </div>
            <div className='labadmin_orders_new_col50'>
              <Button2 Value={'Back'} Action={()=>{
                document.location.replace('/labadmin/orders');
              }}/>
            </div>
          </div>

        </div>
      }
      {page === 1 &&
        <LineItemsAdd lineitems={lineitems} setLineitems={setLineitems} setPage={setPage} editingIndex={editingIndex} setEditingIndex={setEditingIndex}/>
      }
      <ToastContainer/>
    </div>
  )
}

export default Index
